import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { useCreateAccount } from './useCreateAccount';

export const CreateAccount = () => {
  const { errors, onSubmit, register } = useCreateAccount();

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Créer un compte
        </Typography>
        <Box sx={{ mt: 1 }}>
          <form onSubmit={onSubmit}>
            <TextField
              margin="normal"
              fullWidth
              id="email"
              label="Adresse email"
              autoComplete="email"
              autoFocus
              type="email"
              {...register('email')}
              helperText={
                errors.email?.message ? (
                  <Typography component="p" variant="body2" color="error.main">
                    {errors.email.message}
                  </Typography>
                ) : null
              }
            />
            <TextField
              margin="normal"
              fullWidth
              id="confirmEmail"
              label="Confirmer l'adresse email"
              autoComplete="confirmEmail"
              autoFocus
              type="email"
              {...register('confirmEmail')}
              helperText={
                errors.confirmEmail?.message ? (
                  <Typography component="p" variant="body2" color="error.main">
                    {errors.confirmEmail.message}
                  </Typography>
                ) : null
              }
            />
            <TextField
              margin="normal"
              fullWidth
              label="Mot de passe"
              type="password"
              id="password"
              autoComplete="current-password"
              {...register('password')}
              helperText={
                errors.password?.message ? (
                  <Typography component="p" variant="body2" color="error.main">
                    {errors.password.message}
                  </Typography>
                ) : null
              }
            />
            <TextField
              margin="normal"
              fullWidth
              label="Confirmer le mot de passe"
              type="password"
              id="confirmPassword"
              autoComplete="current-password"
              {...register('confirmPassword')}
              helperText={
                errors.confirmPassword?.message ? (
                  <Typography component="p" variant="body2" color="error.main">
                    {errors.confirmPassword.message}
                  </Typography>
                ) : null
              }
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Créer un compte
            </Button>
          </form>
          <Grid container>
            <Grid item>
              <Link href="/login" variant="body2">
                Tu as déjà un compte ? Connecte-toi
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};
